import { render, staticRenderFns } from "./choosePurcharseReturn.vue?vue&type=template&id=1cd5a699&scoped=true"
import script from "./choosePurcharseReturn.vue?vue&type=script&lang=js"
export * from "./choosePurcharseReturn.vue?vue&type=script&lang=js"
import style0 from "./choosePurcharseReturn.vue?vue&type=style&index=0&id=1cd5a699&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5a699",
  null
  
)

export default component.exports